<script setup lang="ts">
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const textboxes = [
  { id: 1, number: '1', title: 'thirddiv.textbox1.title', subtitle: 'thirddiv.textbox1.subtitle' },
  { id: 2, number: '2', title: 'thirddiv.textbox2.title', subtitle: 'thirddiv.textbox2.subtitle' },
  { id: 3, number: '3', title: 'thirddiv.textbox3.title', subtitle: 'thirddiv.textbox3.subtitle' },
  { id: 4, number: '4', title: 'thirddiv.textbox4.title', subtitle: 'thirddiv.textbox4.subtitle' },
];

const tagPills = [
  { id: 1, text: 'thirddiv.flightOptions' },
  { id: 2, text: 'thirddiv.logbook' },
  { id: 3, text: 'thirddiv.chat' },
  { id: 4, text: 'thirddiv.crewMembers' },
  { id: 5, text: 'thirddiv.tripBudget' },
  { id: 6, text: 'thirddiv.playlists' },
  { id: 7, text: 'thirddiv.bookingSummary' },
  { id: 8, text: 'thirddiv.more' },
];
</script>

<template>
  <div class="bg-primary-ciel mt-24">
    <div class="container py-21 grid gap-6 grid-cols-1 sm:grid-cols-1 lg:grid-cols-4">

      <!-- Need Help Section -->
      <div class="relative overflow-hidden rounded-lg group col-span-1 sm:col-span-2 md:col-span-2 lg:col-span-1">
        <div class="flex flex-col justify-between ">
          <h2 class="need-help__title responsive-title-2">{{ t('thirddiv.needHelpTitle') }}</h2>
        </div>
      </div>
      <!-- Textboxes Section -->
      <div class="relative overflow-hidden rounded-lg group sm:col-span-2">
        <div class="grid grid-cols-2 gap-x-6 gap-y-10">
          <div
              v-for="textbox in textboxes"
              :key="textbox.id"
              class="flex flex-col gap-3 textbox"
          >
            <div class="circle flex items-center justify-center responsive-body-xsmall">
              {{ textbox.number }}
            </div>
            <span class="textbox__title font-bold responsive-body-medium">
              {{ t(textbox.title) }}
            </span>
            <span class="textbox__subtitle responsive-body-small text-bw-darkGrey mix-blend-multiply">
              {{ t(textbox.subtitle) }}
            </span>
          </div>
        </div>
      </div>
      
      <!-- Join CTA Section -->
      <div class="relative joincta overflow-hidden rounded-lg group col-span-1 sm:col-span-2 md:col-span-2 lg:col-span-1">
        <div class="bg-white rounded-8xl joincta2 py-10 px-10 flex flex-col h-full justify-between gap-y-8">
          <h2 class="responsive-title-2">{{ t('thirddiv.joinCtaTitle') }} <text class="text-primary-blue">{{ t('thirddiv.place') }}</text></h2>

          <div class="flex flex-wrap gap-2">
            <div
                v-for="tag in tagPills"
                :key="tag.id"
                class="bg-bw-lightGrey w-fit pt-0.5 px-2 rounded-15xl"
            >
              <span class="responsive-body-xsmall">{{ t(tag.text) }}</span>
            </div>
          </div>

          <!-- This will be pushed to the bottom -->
          <span class="responsive-link-small underline font-bold mt-auto">
      {{ t('thirddiv.joinText') }}
    </span>
        </div>
      </div>
      
    </div>
  </div>
</template>

<style scoped>

.circle {
  width: 26px;
  height: 27px;
  border: 1px solid black;
  border-radius: 50%;
  width: max-content;
  aspect-ratio: 1 / 1;
}

.textbox {
  width: 100%;
}

@media (max-width: 768px) {
  .thirddiv {
    grid-template-columns: 1fr;
  }
  .joincta{
    padding-top:40px;
  }
  .joincta2{
    padding-left: 20px!important;
    padding-right: 20px!important; 
  }
}
</style>